// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
	const disabledStyle = {
		"&.Mui-disabled": {
			opacity: "0.5!important",
			color: "#43bd98!important",
			border: "1px solid #43bd98",
		},
	};

	const disabledContainedStyle = {
		"&.Mui-disabled": {
			opacity: "0.5!important",
			color: "#fff!important",
			backgroundColor: "#43bd98",
		},
	};

	const disabledTextStyle = {
		"&.Mui-disabled": {
			opacity: "0.5!important",
		},
	};

	return {
		MuiButton: {
			defaultProps: {
				disableElevation: true,
			},
			styleOverrides: {
				root: {
					fontWeight: 400,
					"&.Mui-disabled": {
						color: "#fff!important",
					},
				},

				contained: {
					...disabledContainedStyle,
					backgroundColor: "#43BD98",
					height: 40,
					width: 120,
					textTransform: "uppercase",
					borderRadius: "6px",
					fontWeight: 700,
					fontSize: "14px",
					color: "white",
					boxShadow: "none",

					"&:hover": {
						backgroundColor: "#3ba685",
					},
				},
				outlined: {
					...disabledStyle,
					border: "1px solid #43BD98",
					color: "#43BD98",
					fontSize: "14px",
					height: 40,
					textTransform: "uppercase",
					borderRadius: "6px",
					fontWeight: 700,

					"&:hover": {
						border: "1px solid #3ba685",
						backgroundColor: "#fcfcfc",
					},
				},
				text: {
					...disabledTextStyle,
					color: "#43BD98",
					fontSize: "14px",
					height: 40,
					textTransform: "uppercase",
					borderRadius: "6px",
					fontWeight: 700,

					"&:hover": {
						opacity: 0.8,
					},
				},
			},
		},
	};
}
